import React from "react";

type Props = {
  isChecked?: boolean;
  onAction?: () => void;
};

const Switch = ({ isChecked, onAction }: Props) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      <input type="checkbox" hidden value="" className="sr-only peer" checked={isChecked} onChange={onAction} />
      <div className="relative w-10 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-[20px] rtl:peer-checked:after:-translate-x-[20px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primaryBlue dark:peer-checked:bg-brightBlue"></div>
    </label>
  );
};

export default Switch;
